import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { Tooltip, CircularProgress, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import { ScrollToTop, isValidRole } from "../../../utils/utils";
import EnableDisableConfig from "./EnableDisableConfig";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import DeleteConfig from "./DeleteConfig";

function SatelliteChannelMapping() {
    const [utilityConfigList, setUtilityConfigList] = useState([]);
    const [confirmDeleteUtilityRow, setConfirmDeleteUtilityRow] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [deleteUtilityPopUp, setDeleteUtilityPopUp] = useState(false);
    const [editUtilityConfig, setEditUtilityConfig] = useState(false);
    const [editUtilityRowUpdate, setEditUtilityRowUpdate] = useState(false);
    const [createUtilitySuccessMsg, setCreateUtilitySuccessMsg] = useState('');
    const [editUtilitySid, setEditUtilitySid] = useState("");
    const [loader, setLoader] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [paginationError, setPaginationError] = useState("")
    const [inputPageValue, setInputPageValue] = useState(1)

    const recordsPerPage = 10;
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        control,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: { active: true }
    });

    let validPermissionClassName = isValidRole("MASTER_CONFIG_SATELLITE_CHANNEL_MAPPING_MODIFY")
    ? ""
    : "btn-disable-permission";

    const onSubmit = (data) => {
        let method = "POST";
        let url = `/hotel-satellite_channel`;
        if (editUtilityRowUpdate) {
            method = "PUT"
            url = `/hotel-satellite_channel?sid=${editUtilitySid?.id}`;
        }

        callAPI(url, method,  data)
            .then(function (response) {
                setLoader(false);
                reset({
                    serviceId: '',
                    lcn: '',
                    active: true,
                });
                setCreateUtilitySuccessMsg(response?.message);
                utilityListApi();
            })
            .catch(function (error) {
                setLoader(false);
                console.warn(error.response?.data?.errorMessage);
            });
    };

    const isUtilityDeletedRef = useRef({
        isUtilityDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteUtilityConfigPopUpHandler = (row) => {
        setDeleteUtilityPopUp(true);
        const newModalRefData = {
            isUtilityDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isUtilityDeletedRef.current = newModalRefData;
    }

    const deleteUtilityHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteUtilityRow === "") {
            return
        }

        if (confirmDeleteUtilityRow === `Delete ${isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}`) {
            setConfirmValidate(false)
            const { row } = isUtilityDeletedRef.current?.isUtilityDeletedModalData;
            callAPI(`/hotel-satellite_channel?sid=${row?.id}`, "DELETE")
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isUtilityDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isUtilityDeletedRef.current = newModalRefData;
                    utilityListApi();
                })
                .catch((error) => {
                    console.warn(error)
                });
        }
        reset({
            serviceId: '',
            lcn: '',
            active: true,
        });
    }

    const renderActionIcon = (row) => {
        return (
            isValidRole("MASTER_CONFIG_SATELLITE_CHANNEL_MAPPING_MODIFY")?<>
                {!row?.active ? <><Tooltip title="Edit" arrow>
                    <MdModeEditOutline
                        className="edit-icon-enable"
                        onClick={() => { setEditUtilityConfig(true); setEditUtilitySid(row) }}
                    />
                </Tooltip>
                    <Tooltip title="Delete" className="cursor-pointer" arrow>
                        <DeleteIcon
                            className="delete-icon-enable"
                            onClick={() => {
                                deleteUtilityConfigPopUpHandler(row);
                            }}
                        />
                    </Tooltip></> :
                    <>
                        <Tooltip title="Disable to perform actions" arrow>
                            <span><MdModeEditOutline className="edit-icon-disable" /></span>
                        </Tooltip>
                        <Tooltip title="Disable to perform actions" arrow>
                            <DeleteIcon className="delete-icon-disable" />
                        </Tooltip>
                    </>
                }

                <EnableDisableConfig row={row} setLoader={setLoader} utilityListApi={utilityListApi} />
            </>:<>
                <Tooltip title="Don't have permission to edit">
                    <span>
                        <MdModeEditOutline className="edit-icon-disable" arrow />
                    </span>
                </Tooltip>
                <Tooltip title="Don't have permission to delete">
                    <DeleteIcon className="delete-icon-disable" arrow />
                </Tooltip>
                <Tooltip title="Don't have permission to edit">
                    <span>
                    <Switch
                    name="active"
                    disabled={true}
                    // onChange={(event) => handleToggleChange(event, props?.row)}
                    inputProps={{ "aria-label": "controlled" }}
                    value={row.active}
                    checked={row.active}
                    className={`${row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                    />
                    </span>
            </Tooltip>
            </>
        );
    };

    const columns = [
        { field: "serviceId", headerName: "Service ID", flex: 1 },
        { field: 'lcn', headerName: 'Channel No', flex: 1 },
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    //Pagination Handle changer
    const onPageChange = (event, value) => {
        setInputPageValue(value)
        setPaginationError("")
        setSelectedPage(value);
    };

    const utilityListApi = () => {
        callAPI(`/hotel-satellite-channel-search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {})
            .then((response) => {
                setUtilityConfigList(response?.channelResponse)
                setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
                setPaginationError("")
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(() => {
        utilityListApi();
    }, [selectedPage]);


    const popupCloseHandler = () => {
        setDeleteUtilityPopUp(false);
    };


    useEffect(() => {
        if (editUtilityConfig) {
            getUtilityListSidHandler();
            setEditUtilityConfig(false);
        }
        ScrollToTop();
    }, [editUtilityConfig]);

    const getUtilityListSidHandler = () => {
        callAPI(`/hotel-satellite-channel-id?sid=${editUtilitySid?.id}`, "GET")
            .then(function (response) {
                const payload = {
                    serviceId: response?.serviceId,
                    lcn: response?.lcn,
                    active: response?.active
                };
                reset(payload);
                setEditUtilityRowUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const resetLayoutHandler = () => {
        reset();
    }

    const cancelUtilityHandler = () => {
        reset({
            serviceId: '',
            lcn: '',
            active: true,
        });
        setEditUtilityRowUpdate(false);
        setEditUtilitySid('');
        setEditUtilityConfig(false);
    }

    const handleSwitchChange = (checked) => {
        setValue("active", checked);
    };


    return (
        <div className='row config-hotel config-management-form'>
            <div className='col-12 left-column'>
                {loader && <div className="circular-progress"><CircularProgress /></div>}
                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
                    <div className="row">
                        <div className="left-column-header">
                            <p className="Roboto-Bold">{editUtilityRowUpdate ? 'Edit Satellite Channel Mapping' : 'Satellite Channel Mapping'}</p>
                        </div>
                        <div className="col-4">
                            <div className="form-group-hotel">
                                <div className="floating-label">
                                    <input
                                        id="serviceId"
                                        // maxLength={25}
                                        placeholder=""
                                        {...register("serviceId", {
                                            required: "Service ID Required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Only Numeric values are allowed",
                                            },
                                        })}
                                    />
                                    <label htmlFor="serviceId">Service ID</label>
                                </div>
                                {errors.serviceId && (
                                    <small className="required">{errors.serviceId.message}</small>
                                )}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group-hotel">
                                <div className="floating-label">
                                    <input
                                        id="lcn"
                                        placeholder=""
                                        {...register("lcn", {
                                            required: "Channel No Required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Only Numeric values are allowed",
                                            },
                                        })}
                                    />
                                    <label htmlFor="lcn">Channel No</label>
                                </div>
                                {errors.lcn && (
                                    <small className="required">{errors.lcn.message}</small>
                                )}
                            </div>
                        </div>

                    </div>
                    <div className="flex-items-between">
                        <div className="status-switch">
                            <p className="mb-0">Satellite Channel Mapping Status</p>
                            <label htmlFor="active">{!watch("active") ? "Disabled" : "Enabled"}</label>
                            <Switch
                                id="active"
                                className={`form-control border-0 ${!watch("active")
                                    ? "switchuser-inactive"
                                    : "switchuser-active"
                                    }`}
                                checked={watch("active")}
                                onChange={handleSwitchChange}
                                {...register("active")}
                            />
                        </div>
                        <div>
                            <button type="button" className="clear-btn me-2" onClick={cancelUtilityHandler}>{editUtilityRowUpdate ? "Cancel" : "Clear All"}</button>
                            {editUtilityRowUpdate && <>
                                <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                            </>}
                            <button type="submit" className={`create-btn ${validPermissionClassName}`}>{editUtilityRowUpdate ? "Update" : "Create"}</button>
                        </div>
                    </div>
                </form>
                <div className="hotel-list">
                    <p><b>Satellite Channel Mapping List</b></p>

                    <TableWrapper
                        data={utilityConfigList}
                        columns={columns}
                        noPagination={true}
                        module="partner-config"
                    />
                    <Custom_Paingation
                        selectedPage={selectedPage}
                        totalPageCount={totalPageCount}
                        paginationError={paginationError}
                        inputPageValue={inputPageValue}
                        setSelectedPage={setSelectedPage}
                        setPaginationError={setPaginationError}
                        setInputPageValue={setInputPageValue}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
            {deleteUtilityPopUp && <DeleteConfig
                deleteUtilityPopUp={deleteUtilityPopUp}
                isUtilityDeletedRef={isUtilityDeletedRef}
                popupCloseHandler={popupCloseHandler}
                deleteUtilityHandler={deleteUtilityHandler}
                setConfirmDeleteUtilityRow={setConfirmDeleteUtilityRow}
                confirmDeleteUtilityRow={confirmDeleteUtilityRow}
                confirmValidate={confirmValidate}
            />}
            <BasicModal
                popupOpen={createUtilitySuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createUtilitySuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateUtilitySuccessMsg(''); setEditUtilityRowUpdate(false); utilityListApi(); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
        </div>
    )
}

export default SatelliteChannelMapping;